import { Comments } from "./Components/Comments";
import { InfoPopup } from "./Components/InfoPopup";
import { ErrorTextModule } from "./Components/ErrorTextModule";
import 'swiper/swiper-bundle.min.css';

class SingleNews {
    constructor() {
        this.$page = $('.single_news');
        this._init();
    }

    _init() {
        this._infoPopup = new InfoPopup({
            page: this.$page,
        });

        this._comments = new Comments({
            page: this.$page,
            infoPopup: this._infoPopup,
        });

        this._errorTextModule = new ErrorTextModule({
            page: this.$page,
            infoPopup: this._infoPopup,
        });

        $('#comments_list_toggle').on('click', function () {
            if ($(this).hasClass('_open')) {
                $('#comments_list').slideUp();
                $(this).removeClass('_open').text($(this).data('open'));
            } else {
                $('#comments_list').slideDown();
                $(this).addClass('_open').text($(this).data('close'));
            }
        });

        if ($('#other_news_list').length) {
            let bus_results_dates = new Swiper("#other_news_list", {
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.other_news_list_wrap .swiper-btn-next',
                    prevEl: '.other_news_list_wrap .swiper-btn-prev',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    }
                }
            });
        }

        $('.news_overlay, .news_popup_close, [data-close-popup]').on('click', function () {
            $('html').removeClass('_open_bus_popup');
            $('.news_overlay').removeClass('_active');
            $('.news_popup').removeClass('_active');
            $('.popup_places').removeClass('_active');
        });
    }
}

$(() => {
    new SingleNews();
});